import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-star\"><path d=\"M13.088 1.46l3.05 6.035 6.822.967c.995.141 1.393 1.335.672 2.02l-4.936 4.698 1.165 6.633c.17.967-.87 1.704-1.76 1.248l-6.1-3.131-6.102 3.131c-.89.457-1.93-.28-1.76-1.248l1.166-6.633-4.938-4.697c-.719-.686-.322-1.878.673-2.02l6.821-.967 3.05-6.035c.447-.881 1.732-.881 2.177 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol